const Theme = {
  Colors: {
    Background: "#1e1e1e",
    Surface: "#252526",
    Card: "#2B2D31",
    Accent: "#007acc",
    Accent2: "#0e639c",
    TextOnBackground: "#cccccc",
    TextMuted: "#858585",
    Border: "#333333",
    Keyword: "#569cd6", 
    String: "#ce9178",
    Function: "#dcdcaa",
    Property: "#9cdcfe"
  },
  Media: {
    Mobile: "@media only screen and (max-width:960px)",
    Portrait: "@media (orientation: portrait)",
  },
};

export default Theme;
